export default function (safariComUser, revenuePartnerId, userAccessId) {
    return {
        msisdn: safariComUser.Msisdn,
        status: getStatus(safariComUser),
        scheme: 'Daily',
        revenuePartnerId: revenuePartnerId,
        grantAccess: getGrantAccess(safariComUser),
        userAccessId: userAccessId,
        username: safariComUser.Username,
        optInServiceMsgs: true,
        automatedEntries: safariComUser.AutomatedEntries,
        loginPromo: false,
        offerCode: safariComUser.OfferCode,
        channelId: safariComUser.ChannelId,
    }
}

function getStatus(safariComUser) {
    const s = (safariComUser.Status || '').toUpperCase();
    if (s === 'ACTIVE' || s === 'PENDING') return "Subscribed"
    else return "Cancelled"
}

function getGrantAccess(safariComUser) {
    const s = (safariComUser.Status || '').toUpperCase();
    return s === 'ACTIVE' || s === 'PENDING'
}
